<template>
  <h1>Pantalla 2</h1>
</template>

<script>
export default {};
</script>

<style>
</style>